<template>
  <div class="community-content">
    <div class="ly-card flex">
      <el-button type="primary" @click.native="() =>add()">发帖</el-button>
      <div class="rg">
        <el-select
          @change="value => change('like_count', value)"
          :value="timeSort"
          placeholder="默认"
          class="p-l-5 p-r-5"
        >
          <el-option label="默认" value="default"></el-option>
          <el-option label="点赞数正序" value="asc"></el-option>
          <el-option label="点赞数倒序" value="desc"></el-option>
        </el-select>
        <el-input placeholder="标题" v-model="searchFormData.title"></el-input>
        <el-input placeholder="所属板块" v-model="searchFormData.category_name"></el-input>
        <el-input placeholder="发帖人" v-model="searchFormData.post_user_name"></el-input>
        <el-date-picker type="date" value-format="yyyy-MM-dd" placeholder="发帖时间" v-model="searchFormData.post_time">
        </el-date-picker>
        <el-select v-model="searchFormData.is_banned" clearable placeholder="帖子状态">
          <el-option label="全部" :value="-1"></el-option>
          <el-option label="已封" :value="true"></el-option>
          <el-option label="正常" :value="false"></el-option>
        </el-select>
        <el-button type="primary" @click="search">查询</el-button>
      </div>
    </div>
    <ly-table
      :getTableData="getTableData"
      :tableHeader="tableHeader"
      :searchFormData="searchFormData"
      class="ly-card"
      ref="lyTable"
    >
      <template v-slot:content="row">
        <el-button type="text" size="mini" @click="detail(row)">{{ row.content | brief }}</el-button>
      </template>
      <template v-slot:action="row">
        <el-dropdown trigger="click" class="dropdown-buttons">
          <span class="el-dropdown-link">更多<i class="el-icon-arrow-down el-icon--right"></i> </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-if="row.post_user_id===-2" @click.native="add(row)">编辑</el-dropdown-item>
            <el-dropdown-item v-if="row.is_topping" @click.native="cancelTop(row)">取消置顶</el-dropdown-item>
            <el-dropdown-item v-else @click.native="top(row)">置顶</el-dropdown-item>
            <el-dropdown-item v-if="row.is_essence" @click.native="cancelEssence(row)">取消精华</el-dropdown-item>
            <el-dropdown-item v-else @click.native="essence(row)">精华</el-dropdown-item>
            <el-dropdown-item v-if="row.is_banned" @click.native="cancelBanned(row)">解封</el-dropdown-item>
            <el-dropdown-item v-else @click.native="banned(row)">封贴</el-dropdown-item>
            <el-dropdown-item class="community-content-danger" @click.native="del(row)">删除</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </template>
    </ly-table>
  </div>
</template>
<script>
import { Input, Select, Option, DatePicker, Dropdown, DropdownItem, DropdownMenu } from 'element-ui';
import LyTable from '@/components/LyTable';
import cPosts from '@/api/cPosts';
import localCache from '@/utils/localCache';
import { CommunityContentTable } from '@/utils/communityHeader';

export default {
  name: 'CommunityContent',
  components: {
    LyTable,
    ElInput: Input,
    ElSelect: Select,
    ElOption: Option,
    ElDatePicker: DatePicker,
    ElDropdown: Dropdown,
    ElDropdownItem: DropdownItem,
    ElDropdownMenu: DropdownMenu
  },
  data() {
    return {
      getTableData: cPosts.postsList,
      tableHeader: CommunityContentTable,
      timeSort: 'default',
      searchFormData: {
        title: '',
        category_name: '',
        post_user_name: '',
        post_time: '',
        is_banned: '',
        sorted_field: 'post_time',
        sorted_type: 'desc'
      }
    };
  },
  mounted() {
    this.search();
  },
  activated() {
    this.search();
  },
  filters: {
    brief(value) {
      if (!value || value.length < 20) return value;
      return `${value.substring(0, 20)}...`;
    }
  },
  methods: {
    search() {
      this.$refs.lyTable.setData();
    },
    top(row) {
      cPosts
        .toppingPosts({
          post_id: row.id
        })
        .then(res => {
          if (res) {
            this.$message.success(res.msg || '置顶成功！');
            this.search();
          }
        });
    },
    cancelTop(row) {
      cPosts
        .cancelToppingPosts({
          post_id: row.id
        })
        .then(res => {
          if (res) {
            this.$message.success(res.msg || '取消置顶成功！');
            this.search();
          }
        });
    },
    essence(row) {
      cPosts
        .essencePosts({
          post_id: row.id
        })
        .then(res => {
          if (res) {
            this.$message.success(res.msg || '加精成功！');
            this.search();
          }
        });
    },
    cancelEssence(row) {
      cPosts
        .cancelEssencePosts({
          post_id: row.id
        })
        .then(res => {
          if (res) {
            this.$message.success(res.msg || '取消加精成功！');
            this.search();
          }
        });
    },
    banned(row) {
      cPosts
        .bannedPosts({
          post_id: row.id
        })
        .then(res => {
          if (res) {
            this.$message.success(res.msg || '封贴成功！');
            this.search();
          }
        });
    },
    cancelBanned(row) {
      cPosts
        .unblockPosts({
          post_id: row.id
        })
        .then(res => {
          if (res) {
            this.$message.success(res.msg || '取消封贴成功！');
            this.search();
          }
        });
    },
    del(row) {
      this.$confirm('确认删除该帖子？', '提示', {
        type: 'warning'
      })
        .then(() => {
          cPosts
            .controlPosts({
              post_id: row.id,
              params: {
                category_id: row.category_id
              },
              methold: 'delete'
            })
            .then(res => {
              if (res) {
                this.$message.success(res.msg || '删除成功');
                this.search();
              }
            });
        })
        .catch(() => {});
    },
    detail(row) {
      this.$router.push(`/${this.$route.params.user_id}/community/content/${row.id}`);
    },
    add(row) {
      localCache.setItem('contentInfo', row);
      this.$router.push(`/${this.$route.params.user_id}/community/content/add/${row ? row.id : -1}`);
    },
    change(key, value) {
      this.timeSort = value;
      if (value === 'default') {
        this.searchFormData.sorted_field = 'post_time';
        this.searchFormData.sorted_type = 'desc';
      } else {
        this.searchFormData.sorted_field = key;
        this.searchFormData.sorted_type = value;
      }
      this.search();
    }
  }
};
</script>
<style lang="less">
.community-content {
  .flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .rg {
    > * {
      margin-left: 10px;
    }
    .el-input {
      width: 150px;
    }
  }
  .el-dropdown-link {
    color: @main-blue;
  }
}
.community-content-danger {
  color: @danger;
}
</style>
